import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import PdfCoRequest from "../../api/PdfCoRequest";
import {prop} from "ramda";

//Helper
const getContentTypeOfFile = (file) => {
  const type = prop("type", file);

  if (type === "application/pdf") {
    return "application/pdf";
  }

  return "application/octet-stream";
};

export const setPdfPage = createAction("pdfViewer/SET_PDF_PAGE", (page) => {
  return {
    payload: { page },
  };
});

export const setPdfTotalPages = createAction("pdfViewer/SET_PDF_TOTAL_PAGES", (page) => {
  return {
    payload: { page },
  };
});

export const setPdfScale = createAction("pdfViewer/SET_PDF_SCALE", (scale) => {
  return {
    payload: { scale },
  };
});

export const receiveDetectGridStructure = createAction(
  "pdfViewer/RECEIVE_DETECT_GRID_STRUCTURE"
);

export const receiveDetectFields = createAction(
  "pdfViewer/RECEIVE_DETECT_FIELDS"
);

export const setPDFFile = createAction("pdfViewer/SET_PDF_FILE");

export const setPDFUrl = createAction("pdfViewer/SET_PDF_URL");

export const setCanvasMarginLeft = createAction(
  "pdfViewer/SET_CANVAS_MARGIN_LEFT",
  (canvasMarginLeft) => {
    return {
      payload: { canvasMarginLeft },
    };
  }
);

export const setCanvasDimensions = createAction(
  "pdfViewer/SET_CANVAS_DIMENSIONS",
  (canvasHeight, canvasWidth) => {
    return {
      payload: { canvasHeight, canvasWidth },
    };
  }
);

export const setCanvasCurrentPageOriginalDimensions = createAction(
  "pdfViewer/SET_CANVAS_CURRENT_PAGE_ORIGINAL_DIMENSIONS",
  (
    currentPageOriginalHeight,
    currentPageOriginalWidth,
    currentPageOriginalRotationAngle
  ) => {
    return {
      payload: {
        currentPageOriginalHeight,
        currentPageOriginalWidth,
        currentPageOriginalRotationAngle,
      },
    };
  }
);

export const resetPdfFileAndUrl = createAction(
  "pdfViewer/RESET_PDF_FILE_AND_URL"
);

export const requestRunTemplate = createAction(
  "pdfViewer/REQUEST_RUN_TEMPLATE"
);

export const setIsCustomFile = createAction(
  "pdfViewer/SET_IS_CUSTOM_FILE",
  (isCustomFile) => {
    return {
      payload: { isCustomFile },
    };
  }
);

export const resetPdfFileData = createAction(
  "pdfViewer/RESET_PDF_FILE_DATA",
  () => {
    return {
      payload: {},
    };
  }
);

export const setPdfFileName = createAction(
  "pdfViewer/SET_PDF_FILE_NAME",
  (pdfFileName) => {
    return {
      payload: { pdfFileName },
    };
  }
);

export const requestConvertToPdf = createAction(
  "pdfViewer/REQUEST_CONVERT_TO_PDF"
);

export const receiveConvertToPdf = createAction(
  "pdfViewer/RECEIVE_CONVERT_TO_PDF"
);

export const requestUploadFileFromUrl = createAction(
  "pdfViewer/REQUEST_UPLOAD_FILE_FROM_URL"
);

export const receiveUploadFileFromUrl = createAction(
  "pdfViewer/RECEIVE_UPLOAD_FILE_FROM_URL"
);

///

export const convertToPdf = createAsyncThunk(
  "pdfViewer/CONVERT_TO_PDF",
  async ({ file }, thunkAPI) => {
    thunkAPI.dispatch(requestConvertToPdf());
    try {
      const preSignedUrlResponse = await PdfCoRequest.getPreSignedUrl(
        {
          name: file.name,
          encrypt: true,
        },
        {
          headers: {
            "Content-Type": getContentTypeOfFile(file),
          },
        }
      );

      await PdfCoRequest.putFileFromUrl(
        preSignedUrlResponse.presignedUrl,
        file,
        {
          customConfig: {
            noToken: true,
          },
          headers: {
            "Content-Type": getContentTypeOfFile(file),
          },
        }
      );

      const sendURL = preSignedUrlResponse.url;
      const response = await PdfCoRequest.convertImageToPdf(sendURL);

      thunkAPI.dispatch(receiveConvertToPdf());
      return { ...response };
    } catch (error) {
      thunkAPI.dispatch(receiveConvertToPdf());
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const setPdfFile = createAction("pdfViewer/SET_PDF_FILE", (file) => {
  return {
    payload: { file },
  };
});

export const setPdfUrl = createAction("pdfViewer/SET_PDF_URL", (url) => {
  return {
    payload: { url },
  };
});

export const markFailToFileUploaded = createAction(
  "pdfViewer/MARK_FAIL_TO_FILE_UPLOADED"
);

export const markSuccessToFileUploaded = createAction(
  "pdfViewer/MARK_SUCCESS_TO_FILE_UPLOADED"
);
